import { gql } from '@apollo/client';

export const QUERY_SCALE_DASHBOARD = gql`
    query QueryScaleDashboard($input: ScaleDashboardQueryInput!) {
        queryScaleDashboard(input: $input) {
            items {
                timePeriod
                pickupHubId
                destHubId
                destWarehouseId
                pickupHubSortingCode
                destHubSortingCode
                destWarehouseSortingCode
                customerType
                customerName
                orderCount
                pickupCount
            }
            dataUpdatedAt
        }
    }
`;
